import { flowConstants } from '../constants';

export function flows(
  state = {
    activeTab: '1'
  },
  action
) {
  switch (action.type) {
    case flowConstants.TOGGLE_ACTIVE_TAB:
      return { ...state, activeTab: action.tab };

    case flowConstants.SET_SELECTED_NODE:
      return { ...state, currentSelectedNode: action.node };

    case flowConstants.FLOW_GET_REQUEST:
      return { ...state, loading: true };
    case flowConstants.GET_EVENT_GROUP_TREE_SUCCESS:
      return { ...state, eventGroupTree: action.data, params: action.params };
    case flowConstants.GET_EVENT_GROUP_TREE_FAILURE:
      return { ...state, error: action.error };
    default:
      return state;
  }
}
